import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { errorMessages } from './error.messages';
import { space } from '../../assets/animations/index';
import { SafeLottie } from '../Lottie/SafeLottie';
import { useDispatch } from 'react-redux';
import { navigate } from '../../redux/navigator/action';
import { strings } from '../../constants/strings';

const ErrorBoundaryComponent = () => {
    const { themeStyle } = useThemeContext();
    const error = useRouteError();
    const dispatch = useDispatch();
    let errroMessage = errorMessages.generic;
    const lottieStyle = {
        height: 200,
        width: '100%',
        marginTop: 40,
    };

    if (isRouteErrorResponse(error)) {
        if (error.status === 404) {
            errroMessage = errorMessages.non_existent;
        }

        if (error.status === 401) {
            errroMessage = errorMessages.unauthorized;
        }

        if (error.status === 503) {
            errroMessage = errorMessages.server;
        }

        if (error.status === 418) {
            errroMessage = errorMessages.wrong_param;
        }
    }

    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                maxWidth: '344px',
            }}
            sx={{ gap: '25px' }}>
            <SafeLottie animationData={space} loop style={lottieStyle} />
            <Box
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    maxWidth: '344px',
                }}
                sx={{ gap: '5px' }}>
                <Typography
                    style={{
                        fontSize: 24,
                        fontWeight: '600',
                        fontFamily: FONT_ENUM.MAIN_BOLD,
                        textAlign: 'center',
                        color: theme[themeStyle].primary_white,
                    }}>
                    {errroMessage.header}
                </Typography>
                <Typography
                    style={{
                        fontSize: 14,
                        fontWeight: '500',
                        fontFamily: FONT_ENUM.MAIN_REGULAR,
                        textAlign: 'center',
                        color: theme[themeStyle].tag_white,
                        maxWidth: '344px',
                    }}>
                    {errroMessage.message}
                </Typography>
            </Box>
            <Button
                onClick={() => {
                    dispatch(navigate({ routes: -1 }));
                }}
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '168px',
                    height: '40px',
                    borderRadius: 100,
                    border: `2px solid ${theme[themeStyle].primary_orange}`,
                }}
                sx={{ gap: '8px', textDecoration: 'none', '&:hover': { cursor: 'pointer' }, textTransform: 'none' }}>
                <Typography
                    style={{
                        fontSize: 14,
                        fontWeight: '600',
                        fontFamily: FONT_ENUM.MAIN_BOLD,
                        textAlign: 'center',
                        color: theme[themeStyle].primary_orange,
                    }}>
                    {strings.go_back}
                </Typography>
            </Button>
        </Box>
    );
};

export { ErrorBoundaryComponent };
